export class WishlistApp {
  constructor () {
    this.handleClick = this.handleClick.bind(this)
    document.addEventListener('click', this.handleClick)

    this.updateWishlistCount()

    this.observeDrawer()

    this.setupListeners()
  }

  setupListeners () {
    document.addEventListener(
      window.BAO.EVENTS.VARIANT.CHANGED,
      this.onVariantChanged.bind(this),
    )
  }

  observeDrawer () {
    this.updatePriceFormatting = this.updatePriceFormatting.bind(this)

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        for (let i = 0; i < mutation.addedNodes.length; i++) {
          if (
            mutation.addedNodes[i].classList &&
            (mutation.addedNodes[i].classList.contains('productContainer') ||
              mutation.addedNodes[i].classList.contains('iwish-row'))
          ) {
            this.updatePriceFormatting()
          }
        }
      })
    })

    const drawerEl = document.querySelector(this.drawerSelector)

    if (drawerEl) {
      observer.observe(drawerEl, {
        childList: true,
        subtree: true,
      })
    }
  }

  updatePriceFormatting () {
    const priceSpanEls = document.querySelectorAll('.price-regular span')
    priceSpanEls.forEach(priceSpanEl => {
      priceSpanEl.innerText = priceSpanEl.innerText.replace(/[.,]00\b/g, '')
    })
  }

  handleClick (e) {
    if (
      e.target.closest(this.drawerSelector) ||
      e.target.closest(this.buttonSelector)
    ) {
      this.updateWishlistCount()
    }

    if (e.target.closest(this.drawerAddToCartSelector)) {
      this.addToCartClick(e.target)
    }
  }

  addToCartClick (target) {
    const atcDisabled = document.body.classList.contains(
      'lyt-Theme-wishlistAtcDisabled',
    )
    if (!atcDisabled) return

    const productLineItem = target.closest('.iwish-row.iwishProduct-row')
    if (productLineItem) {
      productLineItem.querySelector('p.product-title')?.click()
    }
  }

  onVariantChanged (e) {
    const variantId = e.detail?.variant?.data?.id

    if (variantId) {
      document
        .querySelector(this.singleProductSelector)
        ?.setAttribute('data-variant', variantId)
    }
  }

  updateWishlistCount () {
    try {
      if (typeof iWish !== 'undefined') {
        /* eslint-disable-next-line no-undef */
        const wishlistData = iWish.getWishlist()
        const count = JSON.parse(wishlistData)?.length

        const countEls = document.querySelectorAll(this.countSelector)

        countEls.forEach(countEl => {
          countEl.dataset.count = count
          countEl.innerHTML = count
        })
      }
    } catch (err) {
      console.error(err)
    }
  }

  get drawerAddToCartSelector () {
    return `#iwish-drawer-root div.cart-button`
  }

  get drawerSelector () {
    return `#iwish-drawer-root`
  }

  get buttonSelector () {
    return `[data-wishlist-app-external-el="button"]`
  }

  get singleProductSelector () {
    return `[data-wishlist-app-external-el="button"][data-type="single-product"]`
  }

  get countSelector () {
    return `[data-wishlist-app-external-el="count"]`
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.BAO.WishlistApp = new WishlistApp()
})
